<template>
  <v-card tile>
    <v-card-text>
      <h4 mt-2>Vehicules affectés à des travaux</h4>
      <v-divider></v-divider>
     <!-- LISTE vehicule  affecter -->
                        <v-layout row>
                            <v-flex xs12 mt-2>
                                <data-tables mt-3 ml-1 mr-1  ref="multipleTable"  :data="listeBesoinsVeh" style="width:100%;">
                                    <el-table-column prop="id" label="ID" align="center" >
                                         <template slot-scope="scope">
                                             ID-{{scope.row.id}}
                                         </template>
                                    </el-table-column>
                                    <el-table-column prop="dateC" label="DATE" align="center" ></el-table-column>
                                    <el-table-column prop="vehicule" label="VEHICULE ATTRIBUE" align="center"></el-table-column>
                                    <el-table-column prop="periode" label="PERIODE" align="center">
                                        <template slot-scope="scope">
                                             {{scope.row.periode}}
                                         </template>
                                    </el-table-column>
                                    <el-table-column prop="produit" label="VEHICULE DEMANDE" align="center"></el-table-column>
                                    <el-table-column prop="qte" label="QUANTITE" align="center"></el-table-column>
                                    <el-table-column prop="duree" label="DUREE(Jours)" align="center"></el-table-column>
                                    <el-table-column prop="prix" label="MONTANT/(J)" align="center"></el-table-column>
                                    <el-table-column prop="total" label="COUT TOTAL" align="center">
                                        <template slot-scope="scope">
                                             {{scope.row.total}}
                                         </template>
                                    </el-table-column>
                                    <el-table-column prop="demandeur" label="DEMANDEUR" align="center"></el-table-column>
                                    <el-table-column prop="responsables" label="VALIDE PAR PROJET/LOGISTIQUE" align="center"></el-table-column>
                                    <el-table-column prop="libelle" label="PROJET/CHANTIER/TRAVAUX" align="center"></el-table-column>
                                   
                                </data-tables>
                            </v-flex>
                        </v-layout>
                        <!-- LISTE vehicule  affecter -->
    </v-card-text>
    <!-- MODAL VALIDATION BESOIN -->
  </v-card>
</template>

<script>
//liste l'ensemble  des besoins  ou les besoinsa valider par un responsable
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "VehiculeBesoin",
  props: {
    show: {
      type: Boolean
    },
    listeBesoinsVeh: {
      type: Array,
    },
   
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

    };
  },
  methods: {
        //    
  },
  mounted(){
    
  }
};
</script>


// WEBPACK FOOTER //
// src/components/besoin/VehiculeBesoin.vue